export const IsShowCustomTableListCell = (show?: boolean) => {
    return show !== undefined ? show : true;
};

export enum PositionTableActions {
    UNDER = "under",
}
